import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavLinkItem {
  label: string;
  href: string;
}

const navLinks: NavLinkItem[] = [
  { label: '首页', href: '/' },
  { label: '番剧分类', href: '/category/hot-blooded' },
  { label: '动漫文章', href: '/article/article-001' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
              樱花动漫
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 hover:text-primary-500 ${
                  location.pathname === link.href
                    ? 'text-primary-500'
                    : isScrolled
                      ? 'text-foreground-700'
                      : 'text-foreground-900'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer transition-colors duration-200 hover:bg-background-200"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg text-foreground-700"></i>
            </button>
            <Link
              to="/about"
              className="flex items-center gap-1.5 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-user-3-line"></i>
              <span>登录</span>
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-full cursor-pointer hover:bg-background-200 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-lg text-foreground-900 ${
                isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
              }`}
            ></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium py-2 whitespace-nowrap cursor-pointer transition-colors ${
                  location.pathname === link.href
                    ? 'text-primary-500'
                    : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex items-center gap-3 pt-2 border-t border-background-200">
              <button
                className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer hover:bg-background-200 transition-colors"
                aria-label="搜索"
              >
                <i className="ri-search-line text-lg text-foreground-700"></i>
              </button>
              <Link
                to="/about"
                className="flex items-center gap-1.5 text-sm font-medium text-foreground-700 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-user-3-line"></i>
                <span>登录</span>
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}